export const BOTTOM_MENU_DATA = "BOTTOM_MENU_DATA";

export const setBottomMenuData = (data) => ({
  type: BOTTOM_MENU_DATA,
  payload: data,
});
